import React, { useState, useEffect } from "react";
import { kindFood } from "../assetss/data/kindFood";
import KindFoodNavDetail from "./KindFoodNavDetail";
import { useInView } from "react-intersection-observer";

const KindFoodNav = ({ kind , storedId  , active , setActive }) => {
  
  const clickHandler = (kind) => {
    setActive(kind);
  };
  return (
    <ul className="nav-menu h-12 bg-white flex items-center gap-3 px-4 sticky top-20 overflow-x-scroll shadow mb-2 dark:bg-gray-700 dark:shadow-slate-500 z-10 ">
      {kindFood.map((kind) => {
        return (
          <KindFoodNavDetail
            active={active}
            clickHandler={clickHandler}
            setActive={setActive}
            kind={kind}
            storedId={storedId}
            key={kind.id}
          />
        );
      })}
    </ul>
  );
};

export default KindFoodNav;
